export enum appSubscriptionTypes {
  BankConnection = 'BankConnection',
}
